import { render, staticRenderFns } from "./EquipmentDetailSummaryMailing.vue?vue&type=template&id=4310c784&scoped=true&"
import script from "./EquipmentDetailSummaryMailing.vue?vue&type=script&lang=js&"
export * from "./EquipmentDetailSummaryMailing.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentDetailSummaryMailing.vue?vue&type=style&index=0&id=4310c784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310c784",
  null
  
)

export default component.exports